// src/pages/Futures/FuturesTradingViewWidget.js
import React, { useEffect, useRef, useState } from 'react';
import { Box, LinearProgress, Typography, useTheme } from '@mui/material';
import { useSelector } from 'react-redux';

const TV_SRC = 'https://s3.tradingview.com/external-embedding/embed-widget-advanced-chart.js';

export default function FuturesTradingViewWidget() {
  const theme = useTheme();
  const { selectedCoin } = useSelector((s) => s.futures);
  const isLight = theme.palette.mode !== 'dark';

  const containerRef = useRef(null);
  const [booting, setBooting] = useState(false);
  const [err, setErr] = useState(null);

  // إعادة التهيئة عند تغيّر العملة أو الثيم
  useEffect(() => {
    if (!containerRef.current) return;
    // نظّف
    while (containerRef.current.firstChild) containerRef.current.removeChild(containerRef.current.firstChild);

    if (!selectedCoin) {
      setErr('Select a futures pair to load chart.');
      return;
    }

    setBooting(true); setErr(null);

    const script = document.createElement('script');
    script.src = TV_SRC;
    script.type = 'text/javascript';
    script.async = true;

    const cfg = {
      autosize: true,
      symbol: `BINANCE:${selectedCoin}.P`,
      interval: '60',
      timezone: 'Etc/UTC',
      theme: isLight ? 'light' : 'dark',
      style: '1',
      locale: 'en',
      hide_legend: true,
      hide_side_toolbar: false,
      allow_symbol_change: false,
      save_image: false,
      calendar: false,
      support_host: 'https://www.tradingview.com',
    };

    script.innerHTML = JSON.stringify(cfg);
    script.onload = () => setBooting(false);
    script.onerror = () => { setBooting(false); setErr('Failed to load TradingView chart.'); };

    containerRef.current.appendChild(script);

    return () => {
      try {
        while (containerRef.current?.firstChild) containerRef.current.removeChild(containerRef.current.firstChild);
      } catch {}
    };
  }, [selectedCoin, isLight]);

  if (err) return <Typography sx={{ p: 1, color: theme.palette.error.main }}>{err}</Typography>;

  return (
    <Box sx={{ height: '100%', width: '100%', position: 'relative' }}>
      {booting && <LinearProgress sx={{ position: 'absolute', left: 0, right: 0, top: 0, height: 2 }} />}
      <Box ref={containerRef} className="tradingview-widget-container" sx={{ height: '100%', width: '100%' }}>
        <div className="tradingview-widget-container__widget" style={{ height: '100%', width: '100%' }} />
      </Box>
    </Box>
  );
}
